import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { LogIn, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { admin, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && admin) navigate("/admin");
  }, [admin, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <div className="bg-navy-light p-8 text-center border-b border-navy/10">
            <span className="bg-white rounded-md px-4 py-2 inline-flex mb-2">
              <Logo className="h-14" />
            </span>
            <h1 className="font-display text-xl font-bold text-navy mt-3">Administrator Access</h1>
            <p className="text-sm text-dark-text/60">Driven Together Education Program</p>
          </div>
          <div className="p-8">
            <div className="flex items-start gap-3 bg-magenta-light border border-magenta/20 rounded-md p-4 mb-6">
              <ShieldCheck className="text-magenta shrink-0 mt-0.5" size={20} />
              <p className="text-sm text-navy">Access is restricted to authorized AAWTA administrators. Sign in with your approved Google account.</p>
            </div>
            <button onClick={login} data-testid="admin-google-login"
              className="w-full inline-flex items-center justify-center gap-2 bg-magenta hover:bg-magenta-dark text-white font-bold py-3.5 px-6 rounded-md transition-colors">
              <LogIn size={18} /> Sign in with Google
            </button>
            <p className="mt-6 text-center text-xs text-dark-text/50">
              Not an administrator? <a href="/" className="text-navy font-semibold hover:text-magenta">Return to the public site</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
